import RequestBuilder from '../Lib/Requests';

export default class AssetGroupService {
  api = new RequestBuilder();

  buildCreateOrgAssetGroupRequest(params, data, cancelToken) {
    return {
      cancelToken,
      data,
      endpoint: '/v1/assetGroups',
      method: 'post',
      params,
      service: 'gateway',
    };
  }
  async createOrgAssetGroup(params, body, cancelToken) {
    const { data } = await this.api.request(
      this.buildCreateOrgAssetGroupRequest(params, body, cancelToken)
    );
    return data;
  }

  buildUpdateOrgAssetGroupRequest(groupID, data, cancelToken) {
    return {
      cancelToken,
      data,
      endpoint: `/v1/assetGroups/${groupID}`,
      method: 'put',
      service: 'gateway',
    };
  }
  async updateOrgAssetGroup(groupID, body, cancelToken) {
    const { data } = await this.api.request(
      this.buildUpdateOrgAssetGroupRequest(groupID, body, cancelToken)
    );
    return data;
  }

  buildFetchOrgAssetGroupsRequest(params, cancelToken) {
    return {
      cancelToken,
      endpoint: '/v1/assetGroups',
      method: 'get',
      params,
      service: 'gateway',
    };
  }
  async fetchOrgAssetGroups(params, cancelToken) {
    const { data } = await this.api.request(
      this.buildFetchOrgAssetGroupsRequest(params, cancelToken)
    );
    return data;
  }

  buildFetchOrgAssetGroupDetailRequest(groupID, cancelToken) {
    return {
      cancelToken,
      endpoint: `/v1/assetGroups/${groupID}`,
      method: 'get',
      service: 'gateway',
    };
  }
  async fetchAssetGroupDetail(groupID, cancelToken) {
    const { data } = await this.api.request(
      this.buildFetchOrgAssetGroupDetailRequest(groupID, cancelToken)
    );
    return data;
  }

  buildDeleteOrgAssetGroupRequest(groupID, cancelToken) {
    return {
      cancelToken,
      endpoint: `/v1/assetGroups/${groupID}`,
      method: 'delete',
      service: 'gateway',
    };
  }
  deleteOrgAssetGroup(groupID, cancelToken) {
    return this.api.request(
      this.buildDeleteOrgAssetGroupRequest(groupID, cancelToken)
    );
  }

  buildRemoveAssetFromGroupRequest(groupID, assetID, cancelToken) {
    return {
      cancelToken,
      endpoint: `/v1/assetGroups/${groupID}/gateway/${assetID}`,
      method: 'delete',
      service: 'gateway',
    };
  }
  async removeAssetFromGroup(groupID, assetID, cancelToken) {
    const { data } = await this.api.request(
      this.buildRemoveAssetFromGroupRequest(groupID, assetID, cancelToken)
    );
    return data;
  }

  buildAddAssetToGroupRequest(groupID, data, cancelToken) {
    return {
      cancelToken,
      data,
      endpoint: `/v1/assetGroups/${groupID}/gateway`,
      method: 'post',
      service: 'gateway',
    };
  }
  async addAssetToGroup(groupID, body, cancelToken) {
    const { data } = await this.api.request(
      this.buildAddAssetToGroupRequest(groupID, body, cancelToken)
    );
    return data;
  }

  buildUpdateAssetGroupGatewayRequest(groupID, assetID, data, cancelToken) {
    return {
      cancelToken,
      data,
      endpoint: `/v1/assetGroups/${groupID}/gateway/${assetID}`,
      method: 'put',
      service: 'gateway',
    };
  }
  async updateAssetGroupGateway(groupID, assetID, body, cancelToken) {
    const { data } = await this.api.request(
      this.buildUpdateAssetGroupGatewayRequest(
        groupID,
        assetID,
        body,
        cancelToken
      )
    );
    return data;
  }

  buildFetchGatewayAssetGroupsRequest(gatewayID, cancelToken) {
    return {
      cancelToken,
      endpoint: `/v2/gateway/${gatewayID}/assetGroups`,
      method: 'get',
      service: 'gateway',
    };
  }
  async fetchGatewayAssetGroups(gatewayID, cancelToken) {
    const { data } = await this.api.request(
      this.buildFetchGatewayAssetGroupsRequest(gatewayID, cancelToken)
    );
    return data;
  }
}
